import { UserState } from '../../../hooks/useUser';
import { AgencyStats, fetchAgencyStats } from '../../../networkRequest/agencyStatsService';
import { Agency } from '../../../utils/types';

export const getData = async (user: UserState, agency: Agency): Promise<AgencyStats> => {
  const { data, error } = await fetchAgencyStats(user.accessToken, agency.id);
  if (error) {
    throw new Error(error);
  } else if (!data) {
    throw new Error('No data returned');
  }

   return data;
};
